var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBuscaNaoEncontrada(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 203,
    height: 266,
    viewBox: "0 0 203 266",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.1712,
    y: 33.25,
    width: 200.946,
    height: 199.5,
    rx: 99.75,
    fill: "white",
    fillOpacity: 0.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M152.965 259.495C152.965 263.088 138.076 266 119.713 266C101.351 266 86.4647 263.088 86.4647 259.495C86.4647 255.904 101.351 252.989 119.713 252.989C138.076 252.989 152.965 255.904 152.965 259.495Z",
    fill: "white",
    fillOpacity: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M126.343 48.3351C125.978 48.3351 125.634 48.4336 125.329 48.6132C124.228 49.9686 122.988 50.7158 122.061 50.5826C119.956 50.2755 120.143 44.4599 117.529 43.8227C115.617 43.3537 114.666 46.2441 110.633 47.1592C110.063 47.2866 108.991 47.53 107.785 47.4663C106.795 47.414 105.699 47.1477 104.738 46.4353C102.954 45.1146 101.706 42.3514 102.744 40.0345C103.6 38.1056 105.594 37.4859 105.828 37.4164C107.838 36.8254 109.545 37.7523 110.092 38.0479C111.828 38.9919 111.66 39.9707 112.722 40.3068C115.081 41.0482 116.846 36.4781 120.337 36.1595C123.332 35.8814 126.361 38.8413 127.596 41.5695C128.615 43.8227 128.634 46.4467 127.754 48.9144C127.381 48.5553 126.887 48.3351 126.343 48.3351Z",
    fill: "url(#paint0_linear_2403_20202)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M123.539 252.989L125.497 257.643L109.595 264.554L116.741 253.441C118.902 253.338 121.206 253.188 123.539 252.989Z",
    fill: "url(#paint1_linear_2403_20202)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.3125 212.285L33.5566 219.739L12.7364 212.25L29.6565 209.62C32.1515 210.368 34.7587 211.251 37.3125 212.285Z",
    fill: "url(#paint2_linear_2403_20202)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M110.927 154.14C95.4742 155.573 80.5794 155.538 69.0511 157.166C59.3414 184.193 48.2552 201.49 36.182 211.819C33.6658 210.779 31.0969 209.892 28.6386 209.14C37.835 187.906 46.0654 167.571 52.8798 148.576C54.1221 145.109 56.9015 142.424 60.3995 141.355C76.3418 136.478 91.7841 133.064 106.552 131.59C119.444 131.031 131.944 137.16 144.291 146.102C138.569 160.996 129.093 174.88 117.157 188.1C119.678 204.845 120.934 226.966 121.376 252.526C119.047 252.73 116.746 252.883 114.588 252.989C109.129 232.254 103.231 211.849 96.8349 191.825C95.8637 188.788 96.0269 185.497 97.3114 182.583C101.791 172.418 106.316 162.818 110.927 154.14Z",
    fill: "url(#paint3_linear_2403_20202)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M126.941 71.4866C127.389 72.2781 127.854 72.9931 128.342 73.6318C129.043 74.558 130.19 75.0386 131.344 74.8687C131.379 74.8629 131.416 74.8568 131.45 74.851C137.29 74.0012 142.611 71.0356 146.41 66.5399C152.586 59.2253 157.613 51.9165 161.677 45.5923C161.146 38.9163 159.92 32.2642 157.99 25.6295C160.939 24.0702 164.084 22.7574 167.41 21.6848C171.389 28.3079 174.632 36.0387 177.241 44.7483C177.719 46.3367 177.624 48.0424 176.965 49.5663C171.259 62.8064 162.505 77.5939 149.566 93.7767C153.847 112.667 152.031 129.928 145.786 146.011C133.335 137.09 120.73 130.977 107.729 131.534C104.345 120.451 101.885 109.672 100.571 99.2743C84.165 98.0902 69.1287 95.318 56.5423 89.6798C54.894 88.9412 53.7155 87.4466 53.3492 85.6764C51.5948 77.2131 50.618 68.4917 50.3234 59.5477C53.5324 58.5922 56.9776 57.8713 60.6325 57.3439C60.6378 57.3439 66.9257 79.8506 66.9257 79.8506L96.34 78.5671C101.001 78.2915 105.622 77.9224 110.222 77.471C111.204 77.3714 112.082 76.8205 112.611 75.9939C113.152 75.1441 113.606 74.1946 113.983 73.1514C118.299 73.0164 122.614 72.448 126.941 71.4866Z",
    fill: "url(#paint4_linear_2403_20202)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M113.875 70.837C114.826 68.2421 115.268 65.0377 115.231 61.2471L115.239 61.2008C112.148 60.7072 110.016 58.5712 109.634 58.1825C106.667 55.1988 105.907 50.2936 107.565 45.6265C108.781 45.6904 109.862 45.4464 110.437 45.3187C114.503 44.4017 115.462 41.5051 117.39 41.9751C120.026 42.6137 119.838 48.4417 121.96 48.7495C122.895 48.8829 124.145 48.1342 125.234 46.7584C125.562 46.5959 125.909 46.4972 126.277 46.4972C126.826 46.4972 127.324 46.7178 127.7 47.0777C128.124 47.4841 128.389 48.0761 128.389 48.7262C128.389 49.951 127.443 50.9494 126.277 50.9494C126.224 50.9494 126.171 50.9494 126.121 50.9436C126.084 53.7473 124.887 56.4641 122.964 58.4144L122.836 58.5424C123.952 62.8669 125.263 66.4716 126.807 69.1882C122.489 70.1403 118.182 70.7032 113.875 70.837Z",
    fill: "#FFBA88"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M147.182 3.05176e-05C155.359 4.68511 162.037 11.6348 167.421 20.5439C164 21.6403 160.765 22.9822 157.732 24.5761C156.751 21.2208 155.594 17.8657 154.262 14.5226L148.908 11.617L151.676 9.2265L147.182 3.05176e-05Z",
    fill: "#FFBA88"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.3403 44.2207L60.4429 55.6258C56.8886 56.1524 53.5382 56.8721 50.4174 57.8261C50.087 47.5037 50.6368 36.8827 51.912 26.0218L55.4741 38.5036H60.2261L57.3403 44.2207Z",
    fill: "#FFBA88"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M126.799 101.426C132.969 103.168 139.875 105.114 151.519 105.533C151.482 105.111 151.44 104.688 151.4 104.265C140.039 103.853 133.467 102 127.091 100.2C121.004 98.4819 115.252 96.8588 105.983 96.8588C103.461 96.8588 100.157 97.2601 96.5843 97.8759C98.0282 98.0198 99.4774 98.1539 100.94 98.269C100.95 98.3426 100.961 98.4174 100.969 98.4913C102.837 98.2595 104.542 98.1251 105.983 98.1251C115.102 98.1251 120.783 99.7286 126.799 101.426Z",
    fill: "white",
    fillOpacity: 0.5
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.8662 67.8978C52.686 67.9038 53.5031 67.9059 54.3255 67.914C55.9729 67.9298 57.6229 67.9457 59.2808 67.9457C61.1882 67.9457 63.0143 67.8981 64.7799 67.817L64.4594 66.5C62.791 66.5731 61.0753 66.618 59.2808 66.618C57.6281 66.618 55.9807 66.6018 54.336 66.5862C53.4795 66.5779 52.6256 66.5755 51.769 66.5695C51.8032 67.0118 51.8295 67.4563 51.8662 67.8978Z",
    fill: "white",
    fillOpacity: 0.5
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M147.728 133.747C136.256 128.823 123.305 123.267 106.704 122.881C106.809 123.272 106.92 123.666 107.029 124.059C123.236 124.512 135.973 129.974 147.266 134.82C148.109 135.181 148.943 135.538 149.772 135.891C149.875 135.512 149.976 135.131 150.073 134.751C149.297 134.42 148.515 134.085 147.728 133.747Z",
    fill: "white",
    fillOpacity: 0.5
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M147.124 119.04C136.674 116.243 123.67 112.761 107.005 112.761C105.407 112.761 103.871 112.833 102.367 112.95C102.453 113.352 102.54 113.754 102.629 114.157C104.049 114.05 105.498 113.983 107.005 113.983C123.516 113.983 136.439 117.443 146.819 120.222C148.396 120.644 149.921 121.052 151.408 121.435C151.449 121.025 151.484 120.614 151.519 120.203C150.094 119.835 148.63 119.444 147.124 119.04Z",
    fill: "white",
    fillOpacity: 0.5
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M140.127 72.2826C139.596 72.5206 139.057 72.7407 138.508 72.9433C141.112 73.5347 143.721 74.1548 146.27 74.7634C151.094 75.9154 155.993 77.0826 160.952 78.0652C161.185 77.768 161.408 77.4738 161.639 77.178C156.555 76.1826 151.524 74.9847 146.573 73.8029C144.454 73.2966 142.293 72.7825 140.127 72.2826Z",
    fill: "white",
    fillOpacity: 0.5
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M161.437 62.888C156.882 62.888 152.474 62.5835 148.014 62.1631C147.735 62.379 147.467 62.5941 147.182 62.8105C151.862 63.2609 156.624 63.6087 161.437 63.6087C163.267 63.6087 165.551 63.4558 168.128 63.1897C168.378 62.9163 168.625 62.6438 168.867 62.3723C165.966 62.6971 163.408 62.888 161.437 62.888Z",
    fill: "white",
    fillOpacity: 0.5
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M167.267 54.9348C169.234 54.9348 171.24 54.8798 173.18 54.8265C173.473 54.8183 173.761 54.8108 174.049 54.8029C174.248 54.496 174.453 54.1883 174.649 53.8832C174.14 53.8962 173.637 53.9099 173.136 53.9237C171.204 53.9769 169.212 54.0315 167.267 54.0315C165.811 54.0315 160.304 53.9081 155.21 53.4892C154.947 53.7671 154.679 54.0461 154.41 54.3261C160.462 54.8593 167.164 54.9348 167.267 54.9348Z",
    fill: "white",
    fillOpacity: 0.5
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M174.199 33.25C170.393 35.3807 166.153 36.9691 161.639 37.9539C161.697 38.3134 161.756 38.6729 161.809 39.0326C166.417 38.0373 170.748 36.429 174.649 34.2692C174.503 33.9256 174.351 33.5894 174.199 33.25Z",
    fill: "white",
    fillOpacity: 0.5
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M87.9103 78.0653L85.9265 78.156C79.157 83.1897 69.2298 87.6996 60.4429 90.358C61.0234 90.6012 61.6039 90.8445 62.1946 91.0761C65.8864 89.8925 69.7381 88.4008 73.4865 86.6688C79.3556 83.9568 84.2599 81.0089 87.9103 78.0653Z",
    fill: "white",
    fillOpacity: 0.5
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M137.297 83.6565C143.13 83.6565 149.107 84.1496 155.055 84.8127C155.323 84.4236 155.596 84.0317 155.856 83.6441C149.65 82.9389 143.405 82.4022 137.297 82.4022C102.851 82.4022 85.9142 89.2826 74.8995 94.9695C75.5137 95.1236 76.1359 95.2678 76.7554 95.4131C87.7071 89.9281 104.494 83.6565 137.297 83.6565Z",
    fill: "white",
    fillOpacity: 0.5
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.9043 78.0653C61.1363 78.8687 56.2318 79.6061 51.769 80.1179C51.836 80.3972 51.8949 80.6778 51.9671 80.9566C56.4674 80.44 61.4147 79.6995 66.2255 78.8926L65.9043 78.0653Z",
    fill: "white",
    fillOpacity: 0.5
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M112.826 154.685C112.773 154.685 112.717 154.673 112.666 154.65C112.5 154.571 112.438 154.389 112.527 154.242C115.222 149.749 117.918 145.569 120.534 141.817C120.631 141.675 120.842 141.632 120.999 141.719C121.159 141.807 121.209 141.992 121.108 142.134C118.502 145.875 115.815 150.044 113.125 154.525C113.063 154.627 112.948 154.685 112.826 154.685Z",
    fill: "white",
    fillOpacity: 0.5
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.7917 57.8261C50.5893 57.8261 50.4033 57.708 50.3431 57.5252C50.2693 57.3022 50.4088 57.0675 50.6577 57.0009C53.8716 56.1379 57.4684 55.4443 61.3498 54.9394C61.6233 54.9016 61.8886 55.1034 61.8886 55.3564C61.8886 55.589 61.6807 55.7778 61.4209 55.7778C57.649 56.2722 54.0986 56.9572 50.9257 57.8084C50.882 57.8202 50.8382 57.8261 50.7917 57.8261Z",
    fill: "url(#paint5_linear_2403_20202)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M157.748 24.5761C157.59 24.5761 157.434 24.4982 157.353 24.3609C157.239 24.1632 157.322 23.9178 157.54 23.8129C160.424 22.4216 163.551 21.2261 166.838 20.2592C167.075 20.1896 167.324 20.3072 167.4 20.52C167.475 20.7329 167.348 20.9615 167.114 21.0303C163.876 21.9827 160.795 23.16 157.956 24.5291C157.891 24.5612 157.818 24.5761 157.748 24.5761Z",
    fill: "url(#paint6_linear_2403_20202)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M116.074 63.6087C115.521 63.6087 114.965 63.5801 114.41 63.5226C114.1 63.4908 113.89 63.3017 113.939 63.1003C113.989 62.8991 114.275 62.761 114.584 62.7932C115.327 62.8698 116.07 62.8892 116.794 62.8518C118.007 62.7879 119.201 62.5688 120.345 62.2011C120.628 62.1108 120.964 62.1869 121.102 62.37C121.24 62.5529 121.125 62.7741 120.845 62.864C119.573 63.2728 118.241 63.5166 116.886 63.5878C116.616 63.6018 116.347 63.6087 116.074 63.6087Z",
    fill: "url(#paint7_linear_2403_20202)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M141.055 151.793C141.025 151.793 140.992 151.789 140.959 151.781C136.928 150.756 134.347 149.152 133.286 147.015C132.219 144.866 132.678 142.149 134.644 138.939C134.731 138.796 134.941 138.742 135.105 138.815C135.276 138.89 135.339 139.066 135.252 139.209C133.385 142.258 132.935 144.807 133.918 146.787C134.896 148.756 137.33 150.248 141.154 151.222C141.337 151.268 141.439 151.43 141.385 151.585C141.34 151.712 141.205 151.793 141.055 151.793Z",
    fill: "white",
    fillOpacity: 0.5
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M179.7 185.166C176.83 186.193 175.805 189.021 175.805 191.324C175.805 195.082 178.342 198.257 181.342 198.257C184.427 198.257 187.864 194.727 187.864 192.334C187.864 192.006 187.884 191.655 187.905 191.291C187.925 190.926 187.948 190.547 187.948 190.165C187.948 186.235 184.533 184.84 181.612 184.84C180.947 184.84 180.305 184.95 179.7 185.166ZM181.342 199.5C177.715 199.5 174.649 195.756 174.649 191.324C174.649 187.832 176.445 185.021 179.333 183.987C180.054 183.728 180.821 183.598 181.612 183.598C185.343 183.598 189.106 185.629 189.106 190.165C189.106 190.572 189.083 190.977 189.06 191.367C189.04 191.704 189.023 192.03 189.023 192.334C189.023 195.616 184.857 199.5 181.342 199.5Z",
    fill: "url(#paint8_linear_2403_20202)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.58447 97.1656C2.91247 98.1931 1.95903 101.021 1.95903 103.324C1.95903 107.082 4.32027 110.257 7.11234 110.257C9.98444 110.257 13.1838 106.727 13.1838 104.334C13.1838 104.006 13.2026 103.655 13.2214 103.291C13.2403 102.926 13.2615 102.546 13.2615 102.165C13.2615 98.235 10.0833 96.8402 7.36424 96.8402C6.74509 96.8402 6.14712 96.9499 5.58447 97.1656ZM7.11233 111.5C3.73643 111.5 0.883156 107.756 0.883156 103.324C0.883156 99.8325 2.55463 97.021 5.24311 95.9867C5.91405 95.7284 6.62737 95.5978 7.36423 95.5978C10.8367 95.5978 14.3397 97.6285 14.3397 102.165C14.3397 102.572 14.3185 102.977 14.2973 103.367C14.2785 103.704 14.262 104.03 14.262 104.334C14.262 107.616 10.3846 111.5 7.11233 111.5Z",
    fill: "#25E18A"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72.6336 200.946C72.4971 200.946 72.3579 200.904 72.2433 200.82C71.9731 200.622 71.9295 200.26 72.1451 200.013C73.4141 198.554 74.7676 197.124 76.2004 195.611C78.8257 192.836 81.5383 189.965 83.8743 186.745C84.0653 186.482 84.4529 186.409 84.7394 186.586C85.0287 186.762 85.1051 187.118 84.9141 187.382C82.5344 190.664 79.7917 193.562 77.1419 196.364C75.7173 197.869 74.3747 199.29 73.1221 200.73C72.9965 200.872 72.8164 200.946 72.6336 200.946Z",
    fill: "#657496"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M189.935 146.011C189.752 146.011 189.573 145.935 189.452 145.79C188.622 144.808 187.812 143.787 186.955 142.707C184.997 140.241 182.971 137.69 180.612 135.448C180.372 135.219 180.372 134.847 180.612 134.618C180.853 134.388 181.245 134.388 181.485 134.618C183.906 136.917 185.959 139.501 187.942 142C188.795 143.073 189.6 144.087 190.416 145.057C190.63 145.31 190.586 145.68 190.319 145.882C190.205 145.969 190.07 146.011 189.935 146.011Z",
    fill: "#34FDA5"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M161.026 232.75C160.919 232.75 160.81 232.722 160.711 232.662C158.561 231.361 157.201 229.301 155.884 227.309C155.011 225.986 154.184 224.736 153.145 223.686C152.904 223.444 152.904 223.053 153.145 222.812C153.384 222.57 153.772 222.57 154.01 222.812C155.137 223.949 156.037 225.308 156.904 226.623C158.202 228.588 159.428 230.444 161.342 231.602C161.631 231.778 161.725 232.157 161.551 232.45C161.436 232.643 161.235 232.75 161.026 232.75Z",
    fill: "url(#paint9_linear_2403_20202)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61.8886 109.87C64.4707 110.412 67.0021 111.094 69.5601 111.622C69.9504 114.391 70.1936 117.213 70.5625 119.989C68.1194 119.693 65.6736 119.52 63.2679 119.21C62.8723 116.09 62.3644 112.981 61.8886 109.87Z",
    fill: "#0091FF"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2403_20202",
    x1: 63.0941,
    y1: 39.7593,
    x2: 87.603,
    y2: 75.6865,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3E81DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.630939,
    stopColor: "#0E2280"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#011367"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2403_20202",
    x1: 85.5951,
    y1: 255.883,
    x2: 106.52,
    y2: 279.314,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3E81DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.630939,
    stopColor: "#0E2280"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#011367"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2403_20202",
    x1: -24.3545,
    y1: 212.152,
    x2: -9.51486,
    y2: 241.502,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3E81DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.630939,
    stopColor: "#0E2280"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#011367"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2403_20202",
    x1: 100.487,
    y1: 88.525,
    x2: 7.93001,
    y2: 148.757,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00B3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#06F0F3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2403_20202",
    x1: -141.677,
    y1: 52.7992,
    x2: 80.9928,
    y2: 238.354,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3E81DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.630939,
    stopColor: "#0E2280"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#011367"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2403_20202",
    x1: 32.8688,
    y1: 55.6584,
    x2: 35.8228,
    y2: 65.2809,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3E81DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.630939,
    stopColor: "#0E2280"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#011367"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_2403_20202",
    x1: 142.029,
    y1: 21.3246,
    x2: 148.538,
    y2: 33.6932,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3E81DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.630939,
    stopColor: "#0E2280"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#011367"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_2403_20202",
    x1: 103.023,
    y1: 62.5249,
    x2: 104.242,
    y2: 67.4901,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3E81DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.630939,
    stopColor: "#0E2280"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#011367"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_2403_20202",
    x1: 195.973,
    y1: 191.549,
    x2: 180.219,
    y2: 177.944,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00FC96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0091FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_2403_20202",
    x1: 158.353,
    y1: 219.045,
    x2: 150.996,
    y2: 223.354,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00B3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#06F0F3"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuscaNaoEncontrada);
export default __webpack_public_path__ + "static/media/busca-nao-encontrada.b7d56a9d1edca31a56c9aa30d7b83377.svg";
export { ForwardRef as ReactComponent };